import React from "react";

export default () => {
    return (
        <section>
            <h2>Section Coming Soon</h2>
            <p>We're hard at work creating this section of the site. Check back later!</p>
        </section>
    );
};